import mainCaller from './mainCaller';

/**
 * 회원 포인트 API
 * - 지점별 포인트 설정 (적립 on/off, 기본 적립값 P|%, 최소 사용 포인트)
 * - 지점/회원 포인트 내역 조회 (+총 적립/차감 합계)
 * - 운영자 임의 적립/차감
 *
 * 주의: src/api/point.js 는 지점(branch)/상품 관리용 레거시 파일 — 포인트 기능과 무관
 */

// 지점 포인트 설정 조회
export async function getBranchPointSetting(branchId, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/point-setting`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 지점 포인트 설정 저장 (PUT 전체 치환)
// data: { enabledYn, earnType: 'FIXED'|'PERCENT', earnValue, minUsePoint,
//         maxUseType: 'FIXED'|'PERCENT'|null, maxUseValue: number|null,   // null = 상한 없음
//         attendanceEnabledYn, attendancePoint,
//         earnGroups: [{ name, enabledYn, earnType, earnValue, methods: ['CARD'|'CASH'|'TRANSFER'] }],
//         memberGroupPolicies: [{ memberGroupId, attendancePoint, minUsePoint, maxUseType, maxUseValue,
//           appUseYn, earns: [{ method, earnType, earnValue }] }] }   // 전 항목 필수, earns 는 수단마다 하나
export async function updateBranchPointSetting(branchId, data, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/point-setting`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
  });
}

// 지점 포인트 내역 조회 (센터관리 > 포인트 관리)
// query: type=ALL|EARN|DEDUCT & search & startDate & endDate & page & limit
export async function getBranchPointHistories(branchId, query, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/point-histories?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 회원 포인트 조회 (잔액 + 내역 + 합계)
// query: branchId & type & startDate & endDate & page & limit
export async function getMemberPoints(memberId, query, token) {
  return await mainCaller(`admin/api/v1/members/${memberId}/points?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 운영자 임의 적립/차감
// data: { branchId, type: 'EARN'|'DEDUCT', point, staffUserId, memo }
export async function createMemberPoint(memberId, data, token) {
  return await mainCaller(`admin/api/v1/members/${memberId}/points`, 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
}

// 회원 그룹 포인트 일괄 적립/차감 (전원 성공해야 반영 — 한 명이라도 실패하면 아무도 반영 안 됨)
// data: { branchId, type: 'EARN'|'DEDUCT', point, staffUserId, memo, memberIds? }
//   memberIds 를 비우면 그룹 소속 전원이 대상이다.
export async function grantGroupPoints(groupId, data, token) {
  return await mainCaller(`admin/api/v1/member-groups/${groupId}/points`, 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
}

// 회원 집합 포인트 일괄 적립/차감 (전원 성공해야 반영)
// data: { branchId, target: 'ALL'|'MEMBERS', type: 'EARN'|'DEDUCT', point, staffUserId, memo, memberIds? }
//   target='ALL' 은 화면 필터와 무관하게 지점 전체다.
export async function grantPointsInBulk(data, token) {
  return await mainCaller('admin/api/v1/members/points/bulk', 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
}

// 지점 전체 회원 수 (지급 대상 미리보기용)
export async function getBulkGrantBranchCount(branchId, token) {
  return await mainCaller(
    `admin/api/v1/members/points/bulk/branch-count?branchId=${branchId}`,
    'GET',
    null,
    { Authorization: `Bearer ${token}` },
  );
}

// 수기·일괄 지급 한 건 취소 — 그 적립의 잔여분만 회수 (이미 쓴 분은 수기 차감)
export async function cancelMemberPointGrant(memberId, historyId, staffUserId, token) {
  const query = staffUserId ? `?staffUserId=${staffUserId}` : '';
  return await mainCaller(`admin/api/v1/members/${memberId}/points/${historyId}/cancel${query}`, 'POST', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 일괄 지급 묶음 목록
export async function getBulkPointBatches(branchId, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/points/bulk-batches`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 일괄 지급 묶음 취소 — 회원별 잔여분만 회수
export async function cancelBulkPointBatch(branchId, batchId, staffUserId, token) {
  const query = staffUserId ? `?staffUserId=${staffUserId}` : '';
  return await mainCaller(`admin/api/v1/branches/${branchId}/points/bulk-batches/${batchId}/cancel${query}`, 'POST', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 수기·일괄 내역 수정 — 적립: point/expireDate|noExpire/memo/staffUserId, 차감: memo/staffUserId
export async function updateMemberPointHistory(memberId, historyId, data, token) {
  return await mainCaller(`admin/api/v1/members/${memberId}/points/${historyId}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
  });
}
